import { TPreferences } from 'src/app/project/modules/preferences/preferences.model';
import { TPointCustomField } from 'src/app/project/view-models/custom-field-response-model';
import Timeline from '../../Timeline';
import { TTimelineColumns } from '../../timeframes/timeline-timeframes';
import { getNewTimelineElementPosition } from './get-new-timeline-element-position';
import { TIMELINE_TIMEOUT_DURATION, timelineProperties } from './timeline-variables';

export function onTimelineBasicElementMouseUp({
  element,
  preferences,
  elementRect,
  timelineData,
  timeline,
  _pointIndex,
  _timelineField,
}: {
  element: HTMLElement;
  preferences: TPreferences;
  elementRect: DOMRect;
  timelineData: TTimelineColumns;
  timeline: Timeline;
  _pointIndex: number;
  _timelineField: TPointCustomField;
}): void {
  timelineProperties.active = false;

  element.style.cursor = 'grab';
  (element.parentNode as HTMLElement).style.cursor = 'pointer';

  if (timeline.resizing) {
    const { newStartDate, newEndDate } = getNewTimelineElementPosition(
      element,
      preferences,
      elementRect,
      timelineData,
    );

    timeline.updatePointCallback({
      pointIndex: _pointIndex,
      field: _timelineField,
      startDate: newStartDate,
      endDate: newEndDate,
    });
  }

  setTimeout(() => {
    timeline.setResizing(false);
  }, TIMELINE_TIMEOUT_DURATION * 2);

  document.onmouseup = null;
  document.onmousemove = null;
}
